import { AppData, Lightning } from "@lightningjs/sdk"
import { ItemNode } from "../lib/components/grid/ItemNode"
import { Helper } from "../lib/helper"
import { Badge } from "@lightningjs/ui-components"
import { AppSetup } from "../lib/app-setup"
import { AppApiConfig } from "../lib/app-api-config"

export interface VideoMetadataUITemplateSpec extends Lightning.Component.TemplateSpec {
    InfoTextWrapper: object
    item: ItemNode
}

export default class VideoMetadataUI
    extends Lightning.Component<VideoMetadataUITemplateSpec>
    implements Lightning.Component<VideoMetadataUITemplateSpec> {

    static override _template(): Lightning.Component.Template<VideoMetadataUITemplateSpec> {
        return {
            InfoTextWrapper: {
                x: 0,
                y: 0,
                flex: { direction: 'column' },
                Title: { text: { text: '', fontFace: Helper.getFontFamily('Black'), fontSize: 42, wordWrapWidth: 900, maxLines: 2, maxLinesSuffix: '...', textOverflow: 'ellipsis' } },
                MoodsTag: { text: { text: '', fontSize: 26, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff } },
                ItemMetadataWrapper: {
                    y: 10,
                    flex: { direction: 'row', wrap: false },
                    rect: true, color: 0x00000000,
                    children: []
                }
            }
        }
    }

    getPatchObjects(item: ItemNode): any {
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        const bgcolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.bgcolor, 0.5)

        const infoObj: any = {
            Title: { text: item.title, color: 0xffffffff },
            ItemMetadataWrapper: {
                children: []
            },
            MoodsTag: { text: { text: item.mood_tags ? item.mood_tags.split(',').join('  •  ') : ''}}
        }

        const runtimeAlpha = (item.runtime == 0 ? 0 : 1)
        const ageRatingAlpha = (item.age_appropriate_rating == '' ? 0 : 1)
        const popularityRatingAlpha = (item.popularity_rating == -1 ? 0 : 1)
        const releaseDate = item.release_date

        if (releaseDate !== '') {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                flexItem: { marginLeft: 0, marginRight: 40 },
                text: { text: releaseDate, fontSize: 24, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff },
            })
        }
        if (runtimeAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                flexItem: { marginLeft: 0, marginRight: 40 },
                text: { text: Helper.secondsToHms(item.runtime), fontSize: 24, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff },
            })
        }
        if (ageRatingAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                flexItem: { marginLeft: 0, marginRight: 40 },
                type: Badge,
                title: item.age_appropriate_rating, style: { offsetY: 2, paddingX: 30, backgroundColor: bgcolor, radius: 0, textStyle: { fontSize: 22, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff } }
            })
        }

        return infoObj
    }

    set item(item: ItemNode) {
        if (!item) return;
        this.patch({
            InfoTextWrapper: this.getPatchObjects(item),
        })
    }
}
